import { useMemo } from 'react';
import { EnterpriseSeniority } from 'models/Enterprises';
import { sortByName } from 'utils';

export default function useMemberSeniorities(
  memberSeniorities: EnterpriseSeniority[] = [],
) {
  const sortedMemberSeniorities = useMemo(
    () => sortByName(memberSeniorities),
    [memberSeniorities],
  );

  const memberSenioritiesOptions = useMemo(
    () =>
      sortedMemberSeniorities.map(({ _id, name }) => ({
        value: _id,
        label: name,
      })),
    [sortedMemberSeniorities],
  );

  return { sortedMemberSeniorities, memberSenioritiesOptions };
}
